"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRankSuffix = void 0;
const formatRankSuffix = (rank) => {
    const lastDigit = rank % 10;
    const lastTwoDigits = rank % 100;
    if (lastTwoDigits === 11 || lastTwoDigits === 12 || lastTwoDigits === 13) {
        return `th`;
    }
    switch (lastDigit) {
        case 1:
            return `st`;
        case 2:
            return `nd`;
        case 3:
            return `rd`;
        default:
            return `th`;
    }
};
exports.formatRankSuffix = formatRankSuffix;
